import featureToggles from 'shared/featureToggles'

export const FLOW_STEP_DATE = 'startDate'
export const FLOW_STEP_PRODUCT = 'product'
export const FLOW_STEP_DELIVERY = 'delivery'
export const FLOW_STEP_REVIEW = 'reviewPay'
export const FLOW_STEP_SUCCESS = 'success'
export const FLOW_STEP_VEHICLE = 'vehicles'

export const PURCHASE_FLOW = [
    FLOW_STEP_DATE,
    FLOW_STEP_PRODUCT,
    featureToggles.hasSubcriptionLite ? FLOW_STEP_VEHICLE : null,
    FLOW_STEP_DELIVERY,
    FLOW_STEP_REVIEW,
].filter(step => step)

export const CREDENTIAL_LPR = 'LPR'
export const CREDENTIAL_PHYSICAL = 'Physical'

export const DELIVERY_COLLECT = 'collect'
export const DELIVERY_HOME = 'send_to_address'
